import {Slide} from "./Slide";

export class Story {
  public id;
  public pptx;
  public name;
  public sort;
  public groupId;
  public groupName;
  public slides: Slide[] = [];

  constructor(name?, sort?) {
    this.name = name;
    this.sort = sort ? sort : 10;
  }

  public equals(s:Story) : boolean {
    return (
      s
      && this.id === s.id
    );
  }

  static fromConfig(config): Story {
    let i = new Story();
    console.log('config', config);
    if (Array.isArray(config)) {
      i.slides = config.map(slideConfig => { return Slide.fromConfig(slideConfig);});
    } else {
      i.id = config.hasOwnProperty('id') ? config.id : null;
      i.name = config.hasOwnProperty('name') ? config.name : null;
      i.pptx = config.hasOwnProperty('pptx') ? config.pptx : null;
      i.groupId = config.hasOwnProperty('groupId') ? config.groupId : null;
      i.groupName = config.hasOwnProperty('groupName') ? config.groupName : null;
      i.slides = config.hasOwnProperty('slides') ? config.slides.map(slideConfig => { return Slide.fromConfig(slideConfig);}) : [];
    }
    return i;
  }
}

